import React from 'react'
import { Page } from '@shopify/polaris'

export default function ComingSoonPage() {
  return (
    <Page title="Coming Soon">
    </Page>
  )
}
